import { useEffect } from 'react';
import { useAuth } from '@/lib/auth';
import { apiUrl } from '@/lib/api-url';

const HEARTBEAT_INTERVAL_MS = 3 * 60 * 1000;

export function useHeartbeat() {
  const { token } = useAuth();

  useEffect(() => {
    if (!token) return;

    const sendHeartbeat = () => {
      fetch(apiUrl('/api/sessions/heartbeat'), {
        method: 'POST',
      }).catch(() => {});
    };

    sendHeartbeat();

    const id = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(id);
  }, [token]);
}
